import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './wallet-loading-page.component.html'
})
export class WalletLoadingPageComponent {
    constructor(@Inject('ENV') public env: Env) {}
}
